import "./AppTextAreaV2.scss";

import Form from "react-bootstrap/Form";
import React from "react";

const AppTextAreaV2 = ({
  label,
  name,
  value,
  onChange,
  onBlur,

  errors = {},
  touched = false,

  isRequired = false,
  disabled = false,
  readOnly = false,

  rows = 4,
  placeholder,
  formText,
  maxLength,

  className = "",
}) => {
  const hasError = !!errors?.[name] && !!touched;

  return (
    <div
      className={`hallapp-textarea-v2 ${className} ${
        disabled ? "is-disabled" : ""
      } ${hasError ? "is-error" : ""}`}
    >
      {label && (
        <div className="hallapp-textarea-v2__label">
          <span>{label}</span>
          {isRequired && (
            <span className="hallapp-textarea-v2__required">
              {" "}
              *(obrigatório)
            </span>
          )}
        </div>
      )}

      <div
        className={`hallapp-textarea-v2__wrap ${
          readOnly ? "is-readonly" : ""
        }`}
      >
        <Form.Control
          as="textarea"
          name={name}
          value={value ?? ""}
          onChange={onChange}
          onBlur={onBlur}
          rows={rows}
          placeholder={placeholder || label}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          className="hallapp-textarea-v2__control"
        />
      </div>

      <div className="hallapp-textarea-v2__meta">
        {hasError ? (
          <div className="hallapp-textarea-v2__error">
            {errors?.[name]}
          </div>
        ) : formText ? (
          <div className="hallapp-textarea-v2__help">{formText}</div>
        ) : null}
      </div>
    </div>
  );
};

export default AppTextAreaV2;
